/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

export default function ExpandIcon({
  width = 11,
  height = 11,
}) {
  return (
    <span
      style={{
        display: 'inline-flex',
        width,
        height,
        flexShrink: 0,
      }}
      aria-hidden
    >
      <svg width="100%" height="100%" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 3.5C10.2239 3.5 10 3.27614 10 3V1.70711L6.85355 4.85355C6.65829 5.04882 6.34171 5.04882 6.14645 4.85355C5.95118 4.65829 5.95118 4.34171 6.14645 4.14645L9.29289 1H8C7.72386 1 7.5 0.776142 7.5 0.5C7.5 0.223858 7.72386 0 8 0H10C10.5523 0 11 0.447715 11 1V3C11 3.27614 10.7761 3.5 10.5 3.5Z" fill="#3C5873" />
        <path d="M0.5 7.5C0.776142 7.5 1 7.72386 1 8V9.29289L4.14645 6.14645C4.34171 5.95118 4.65829 5.95118 4.85355 6.14645C5.04882 6.34171 5.04882 6.65829 4.85355 6.85355L1.70711 10H3C3.27614 10 3.5 10.2239 3.5 10.5C3.5 10.7761 3.27614 11 3 11H1C0.447715 11 0 10.5523 0 10V8C0 7.72386 0.223858 7.5 0.5 7.5Z" fill="#3C5873" />
      </svg>
    </span>
  );
}

ExpandIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};
